export enum Language {
    pt = 'PT',
    en = 'EN'
}